'use client';

import React from 'react';
import { MatrixDisplay } from '@/components/ui/home/matrix-display';
import { HeadingText } from '@/components/ui/home/hero-text';
import { HeroInfo } from './hero-info';
import { FoundersInfo } from './founders-info';
import { VideoPlayer } from './video-player';
import { OverlayText } from '@/components/ui/common/overlay-text';
import { VideoData } from '@/lib/utils/media.utils';

interface MegaHeroProps {
  videoThumbnail?: string;
  heroText?: string;
  videoData?: VideoData | null;
}

export function MegaHero({ videoThumbnail = null, videoData = null, heroText }: MegaHeroProps) {
  return (
    // <div className="relative w-full h-[92vh] min-h-[600px] overflow-hidden bg-white">
    <div className="relative w-full h-full min-h-[250px] lg:min-h-[600px] overflow-y-auto lg:overflow-hidden bg-white">
      {/* White background gradient */}
      {/* <div className="absolute inset-0 bg-linear-to-b from-white/95 to-white z-0"></div> */}

      {/* Hero information overlay (title, subtitle, metadata) - limited area */}
      {/* <div className="static lg:absolute left-0 top-0 w-2/3 h-2/3 z-20 pointer-events-none">
        <HeroInfo title={title} subtitle={subtitle} projectMeta={projectMeta} />
      </div> */}

      <div className="flex flex-col h-full justify-between">
        <div>
          {/* Dynamic text component - limited area */}
          <OverlayText className="static lg:absolute w-full lg:w-[50%] p-[15px] " text={heroText} />

          {/* Matrix text effect in background */}
          <div className="static lg:absolute top-4 right-4 z-10 p-[15px] lg:p-[0] pointer-events-none">
            <MatrixDisplay />
          </div>
        </div>
        <div>
          {/* Video Player Component with highest z-index */}
          {videoData && <VideoPlayer videoData={videoData} thumbnailSrc={videoThumbnail} />}

          {/* Founders Information with 15px padding */}
          <div className="static md:absolute bottom-[8px] ml-[15px] z-30">
            <FoundersInfo />
          </div>
        </div>
      </div>
    </div>
  );
}
